module.exports = __webpack_public_path__ + "static/media/sedrr.c07b63b0.png";